export const tickets = [
  {
    id: "IT-2025-001",
    title: "VPN Connection Issues",
    submittedBy: "Ashley Palma",
    priority: "high",
    status: "open",
    category: "Network",
    description: "Unable to connect to company VPN from remote location. Getting timeout error.",
    replies: 3,
    lastUpdated: "2 hours ago"
  },
  {
    id: "IT-2025-002",
    title: "Password Reset Request",
    submittedBy: "Saccharine Elupre",
    priority: "medium",
    status: "in-progress",
    category: "Account",
    description: "Need to reset my email account password. Unable to access through self-service.",
    replies: 1,
    lastUpdated: "5 hours ago"
  },
  {
    id: "IT-2025-003",
    title: "Software Installation - Adobe Creative Suite",
    submittedBy: "Emily Rodriguez",
    priority: "low",
    status: "resolved",
    category: "Software",
    description: "Request for Adobe Creative Suite installation on work laptop.",
    replies: 5,
    lastUpdated: "1 day ago"
  },
  {
    id: "IT-2025-004",
    title: "Laptop Running Slow",
    submittedBy: "James Wilson",
    priority: "medium",
    status: "open",
    category: "Hardware",
    description: "Work laptop has been running extremely slow for the past week. Need assistance.",
    replies: 2,
    lastUpdated: "3 hours ago"
  },
  {
    id: "IT-2025-005",
    title: "Email Not Syncing on Mobile",
    submittedBy: "Lisa Anderson",
    priority: "medium",
    status: "in-progress",
    category: "Mobile",
    description: "Work email not syncing properly on iPhone. Missing recent messages.",
    replies: 4,
    lastUpdated: "6 hours ago"
  }
];
